import React from 'react';
import { botonesOfrecidos, botonElegido } from '../../utils/botonesDeMensaje';

/**
 * Debajo del cuerpo de la burbuja: las opciones que llevó un saliente, o el botón que el
 * cliente tocó en un entrante. Sin datos no pinta nada (los mensajes de hoy no traen ninguno).
 * La decisión de qué mostrar vive en `utils/botonesDeMensaje.js`, que sí se prueba.
 */
export default function BotonesDeMensaje({ msg, t }) {
  const ofrecidos = botonesOfrecidos(msg);
  const elegido = botonElegido(msg);
  if (ofrecidos.length === 0 && !elegido) return null;
  const chip = { display: 'inline-block', padding: '0.15rem 0.55rem', borderRadius: '999px', border: '1px solid #cbd5e0', fontSize: '0.75rem', marginRight: '0.3rem', marginTop: '0.3rem', background: '#f7fafc', color: '#2d3748' };
  return (
    <div style={{ marginTop: '0.35rem' }} data-testid="botones-de-mensaje">
      {ofrecidos.length > 0 && (
        <div title={t('detail.botones.ofrecidos')}>
          {ofrecidos.map((b) => <span key={b.id || b.texto} style={chip}>{b.texto}</span>)}
        </div>
      )}
      {elegido && (
        <div style={{ fontSize: '0.75rem', opacity: 0.85, marginTop: '0.25rem' }}>
          ↩︎ {t('detail.botones.elegido')}: <strong>{elegido.texto || elegido.id}</strong>
        </div>
      )}
    </div>
  );
}
